// ─────────────────────────────────────────────────────────────────────────────
// Los dos avisos del armazón de la maqueta: «Métricas unificadas» y «Auditoría activa», más la línea
// «Mostrando…» que dice, en una frase, sobre qué se está mirando.
//
// 🔴 Los dos avisos afirman algo, así que solo se pintan si es CIERTO en esta pantalla:
//
//   · «Auditoría activa» se condiciona a `canExportData`. Lo que se audita es la DESCARGA
//     (`registrarExport`, en Líderes y Moderación); a quien no puede exportar, el aviso le prometería
//     un registro que no va a existir y, peor, le sugeriría que su lectura queda fichada.
//   · «Métricas unificadas» se mudó a `BannerHomologacion`, que la maqueta pone justo debajo de las
//     pestañas. Aquí quedaría duplicada.
//
// La línea «Mostrando…» NO repite los tags de filtro de arriba: aquellos son controles removibles
// («Fechas: … ×»), y esto es una frase de lectura. Con los filtros por omisión dice «toda la
// organización» en vez de callar, porque «sin filtros» es también un alcance y conviene verlo escrito
// antes de leer una cifra.
// ─────────────────────────────────────────────────────────────────────────────
import { useTranslation } from 'react-i18next';

export interface BannersDeContextoProps {
  /** Nombre de la OU del filtro, ya resuelto. Vacío o ausente = toda la organización. */
  readonly ouName?: string | null;
  /** Rango del filtro, ya formateado. Ausente = sin acotar. */
  readonly rango?: string | null;
  /** Fundamental del filtro, ya resuelto a nombre. */
  readonly fundamentalName?: string | null;
  /**
   * Si esta persona puede descargar. Decide si el aviso de auditoría es cierto para ella: lo que
   * queda registrado es la descarga, no la consulta.
   */
  readonly canExportData: boolean;
}

export function BannersDeContexto({
  ouName, rango, fundamentalName, canExportData,
}: BannersDeContextoProps) {
  const { t } = useTranslation('recognition');

  const partes = [
    ouName?.trim() ? ouName : t('reports.context.wholeOrg'),
    rango?.trim() ? rango : null,
    fundamentalName?.trim() ? fundamentalName : null,
  ].filter(Boolean) as string[];

  return (
    <div className="rr-context">
      <div className="rr-context-banners">
        {canExportData && (
          <p className="rr-context-banner rr-context-banner--audit">
            <i className="fas fa-shield-halved" aria-hidden="true" />
            <span>
              <strong>{t('reports.context.auditTitle')}</strong> {t('reports.context.auditText')}
            </span>
          </p>
        )}
      </div>

      <p className="rr-context-showing">
        {t('reports.context.showing')} <strong>{partes.join(' · ')}</strong>
      </p>
    </div>
  );
}
